var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconColumn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 10",
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.026 2.117c0-.574.465-1.039 1.038-1.039h6.923c.574 0 1.039.465 1.039 1.039v5.538c0 .574-.465 1.039-1.039 1.039H1.064A1.038 1.038 0 01.026 7.655V2.117zm1.038-.346a.346.346 0 00-.346.346v5.538c0 .192.155.347.346.347h6.923a.346.346 0 00.347-.347V2.117a.346.346 0 00-.347-.346H1.064z",
    fill: "#7D8791"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.026 3.155h9v3.462h-9V3.155zm.692.693v2.077h7.616V3.848H.718z",
    fill: "#7D8791"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.141 1.425c0-.383.31-.693.693-.693h1.384c.383 0 .693.31.693.693v6.923c0 .382-.31.692-.693.692H3.834a.692.692 0 01-.693-.692V1.425z",
    fill: "#7D8791"
  })));
}
export default SvgIconColumn;